import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';

/** Career Pathways demo builder. Scaffolding — filled in a later phase. */
export function buildCareerPathwaysDemo(
  _config: Extract<DemoProductConfig, { kind: 'career-pathways' }>,
  _scenario: DemoScenario
): DemoScenarioResolved {
  return { matchers: [], seed: [] };
}
